import FlourishComponent from 'components/FlourishComponent';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const SroiTimingBarChart = ({ data }, ref) => {
  const [chartLoaded, setChartLoaded] = React.useState(false);
  return (
    <Row className='report-second d-flex to-break w-100 p-0'>
      <Col className={`simple-box d-flex flex-column justify-content-center col-12 m-0`}>
        <Row className='ml-0'>
          <h5 className='title-simple-box text-uppercase mt-1 pl-0'>
            {/* {translations.filter((trans) => trans.code === 'ICS129').map((trans) => trans.text)} */}
            SROI Timing
          </h5>
        </Row>
        <FlourishComponent
          visualizationId='19383790'
          containerId={`lineChartContainer_SROI`}
          style={{ width: '100%' }}
          withFooter={false}
          ref={ref}
          onChartLoad={() => {
            setChartLoaded(true);
          }}
          data={{
            bindings: {
              data: {
                filter: 0,
                label: 1,
                metadata: [],
                value: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
              },
            },
            data: {
              data: data || [],
            },
            metadata: {
              data: {
                0: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                },
                1: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                },
                2: {
                  type_id: 'number$point_comma',
                  type: 'number',
                },
                3: {
                  type_id: 'number$point_comma',
                  type: 'number',
                },
                4: {
                  type_id: 'number$point_comma',
                  type: 'number',
                },
                5: {
                  type_id: 'number$point_comma',
                  type: 'number',
                },
                6: {
                  type_id: 'number$point_comma',
                  type: 'number',
                },
                7: {
                  type_id: 'number$point_comma',
                  type: 'number',
                },
                8: {
                  type_id: 'number$point_comma',
                  type: 'number',
                },
                9: {
                  type_id: 'number$point_comma',
                  type: 'number',
                },
                10: {
                  type_id: 'number$point_comma',
                  type: 'number',
                },
                11: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
                12: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
                13: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
                14: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
                15: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
                16: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
                17: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
                18: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
                19: {
                  type_id: 'number$none_point',
                  type: 'number',
                  output_format_id: 'number$comma_point',
                },
              },
            },
          }}
          // dataToRespond={[...extractedData.flat()]}
        />
      </Col>
    </Row>
  );
};

export default SroiTimingBarChart;
